import { useIsMobile } from 'designSystem/hooks/useMobile'
import { useNavbarConfig } from 'features/navbar/useNavbarConfig'
import { useSelectedOrgAndSiteInterface } from 'features/orgAndSiteSourceOfTruth'

/** Mobile viewport inside the embedded sidebar shell. */
export function useIsEmbeddedMobileLayout(): boolean {
  const isMobile = useIsMobile()
  const { getOrganizationId, getSiteId } = useSelectedOrgAndSiteInterface()
  const { embeddedSidebar } = useNavbarConfig({
    orgId: getOrganizationId() ?? '',
    siteId: getSiteId(),
  })
  return isMobile && embeddedSidebar
}
